import { render, staticRenderFns } from "./ParallaxHeroSection.vue?vue&type=template&id=3530d9f0&"
import script from "./ParallaxHeroSection.vue?vue&type=script&lang=js&"
export * from "./ParallaxHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxHeroSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports